module.exports = __webpack_public_path__ + "img/Exhibition_Logo.bc263274.jpg";